import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import dashboard from './dashboardPage/handler';
import reservationsPage from './reservationsPage/handler';
import freeridePage from './freeridePage/handler';
import callPage from './callPage/handler';

export default pipeHandlers(common, dashboard, reservationsPage, freeridePage, callPage);
